import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import { baseUrl, userLocation, ipAddress, userName } from "../Univ.js";

function EditBreakdown() {
  const { id } = useParams();
  const [machines, setMachines] = useState([]);
  const [data, setData] = useState({
    machine_id: "",
    description: "",
    breakdown_date: "",
    downtime_hours: ""
  });

  useEffect(() => {
    fetchBreakdown();
    fetchMachines();
  }, []);

  const fetchBreakdown = () => {
    axios.get(baseUrl + "breakdowns/" + id + "/")
      .then(res => setData({
        machine_id: res.data.machine?.id || "",
        description: res.data.description,
        breakdown_date: res.data.breakdown_date,
        downtime_hours: res.data.downtime_hours
      }))
      .catch(() => Swal.fire("Error", "Could not fetch breakdown", "error"));
  };

  const fetchMachines = () => {
    axios.get(baseUrl + "machines/").then(res => setMachines(res.data));
  };

  const inputHandler = (e) => setData({ ...data, [e.target.name]: e.target.value });

  const formSubmit = () => {
    const _formData = new FormData();
    _formData.append("machine", data.machine_id);
    _formData.append("description", data.description);
    _formData.append("breakdown_date", data.breakdown_date);
    _formData.append("downtime_hours", data.downtime_hours);
    _formData.append("status", "1");
    _formData.append("addedby", userName);
    _formData.append("ip_add", ipAddress);
    _formData.append("location", userLocation);

    axios.put(baseUrl + "breakdowns/" + id + "/", _formData, { headers: { "Content-Type": "multipart/form-data" } })
      .then(() => Swal.fire({ title: "Updated", icon: "success", timer: 2000, showConfirmButton: false }))
      .then(() => window.location.href = "/breakdown/")
      .catch(() => Swal.fire("Error", "Update failed", "error"));
  };

  return (
    <div className="container mt-4">
      <div className="card p-4">
        <h4>Edit Breakdown</h4>

        <select name="machine_id" value={data.machine_id} onChange={inputHandler} className="form-control mt-3">
          <option value="">Select Machine</option>
          {machines.map(m => <option key={m.id} value={m.id}>{m.name}</option>)}
        </select>

        <input type="date" className="form-control mt-3" name="breakdown_date" value={data.breakdown_date} onChange={inputHandler} />
        <input type="number" className="form-control mt-3" placeholder="Downtime Hours" name="downtime_hours" value={data.downtime_hours} onChange={inputHandler} />
        <textarea className="form-control mt-3" placeholder="Description" name="description" value={data.description} onChange={inputHandler}></textarea>

        <button className="btn btn-primary mt-3" onClick={formSubmit}>Update</button>
      </div>
    </div>
  );
}

export default EditBreakdown;
